export const TicketsListSkeleton = () => {
  return (
    <div className="flex flex-col pr-4 gap-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex gap-2">
          <div className="skeleton-text w-6 h-6" />
          <div className="skeleton-text w-[70%] h-6" />
        </div>
      ))}
    </div>
  );
};
